import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue"
import SelfProfile from "@/views/SelfProfile.vue";
import SaveSession from "@/views/SaveSession.vue";
import OtherProfile from "@/views/OtherProfile.vue";
import UserProfile from "@/views/UserProfile.vue"
import store from "@/store/index.js"

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/profile",
    name: "profile",
    component: SelfProfile,
    beforeEnter: (to, from, next) => {
      if ((from.path !== "/  " || from.path !== "/other") && !store.getters.isUserLoggedIn) {
        next(false);
      }
      else next();
    }

  },
  {
    path: "/user/:nickname",
    name: "user",
    component: UserProfile,
  },
  {
    path: "/save",
    name: "saveSession",
    component: SaveSession,
    beforeEnter: (to, from, next) => {
      if ((from.path !== "/  " || from.path !== "/other") && !store.getters.isUserLoggedIn) {
        next(false);

      }
      else next();
    }
  },
  {
    path: "/other",
    name: "other-profile",
    component: OtherProfile
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
